import { accountTypes, CENTRAL_TIMETABLER_VIEW_TYPE } from '.';
import { FACILITIES_VIEW_TYPE, ACADEMIC_VIEW_TYPE } from './';

export const hasRouteAccess = (item: any, viewType: string, accountType: string) =>
    item.viewType.includes(viewType) && item.accountType.includes(accountType);

export const mainListItems = [
    {
        title: 'Home',
        route: '/',
        viewType: [FACILITIES_VIEW_TYPE, ACADEMIC_VIEW_TYPE, CENTRAL_TIMETABLER_VIEW_TYPE],
        accountType: [accountTypes.superAdmin, accountTypes.admin, accountTypes.timetabler, accountTypes.instructor, accountTypes.reader, accountTypes.facilities, accountTypes.centralTimetabler],
    },
    {
        title: 'Timetable',
        route: '/timetable',
        viewType: [FACILITIES_VIEW_TYPE, ACADEMIC_VIEW_TYPE, CENTRAL_TIMETABLER_VIEW_TYPE],
        accountType: [accountTypes.superAdmin, accountTypes.admin, accountTypes.timetabler, accountTypes.reader, accountTypes.facilities, accountTypes.centralTimetabler],
    },
    {
        title: 'Battleship',
        route: '/battleship',
        viewType: [ACADEMIC_VIEW_TYPE, CENTRAL_TIMETABLER_VIEW_TYPE],
        accountType: [accountTypes.superAdmin, accountTypes.admin, accountTypes.timetabler, accountTypes.centralTimetabler],
    },
    {
        title: 'Office Hours',
        route: '/office-hours',
        viewType: [ACADEMIC_VIEW_TYPE],
        accountType: [accountTypes.superAdmin, accountTypes.admin, accountTypes.timetabler, accountTypes.instructor],
    },
    //Personalized for instructors
    {
        title: 'Personal Info',
        route: '/instructors',
        viewType: [ACADEMIC_VIEW_TYPE],
        accountType: [accountTypes.instructor],
    },
];

export const eventListItems = [
    {
        title: 'Banner Event',
        route: '/banner-event',
        viewType: [FACILITIES_VIEW_TYPE, CENTRAL_TIMETABLER_VIEW_TYPE],
        accountType: [accountTypes.superAdmin, accountTypes.facilities, accountTypes.centralTimetabler],
    },
    {
        title: 'Event Grid',
        route: '/event-grid',
        viewType: [FACILITIES_VIEW_TYPE, CENTRAL_TIMETABLER_VIEW_TYPE],
        accountType: [accountTypes.superAdmin, accountTypes.facilities],
    },
    {
        title: 'Contact',
        route: '/contact',
        viewType: [FACILITIES_VIEW_TYPE, CENTRAL_TIMETABLER_VIEW_TYPE],
        accountType: [accountTypes.superAdmin, accountTypes.facilities],
    },
    {
        title: 'Item List',
        route: '/item-list',
        viewType: [FACILITIES_VIEW_TYPE, CENTRAL_TIMETABLER_VIEW_TYPE],
        accountType: [accountTypes.superAdmin, accountTypes.facilities],
    },
]

export const manageListItems = [
    {
        title: 'Term Listing',
        route: '/term-listing',
        viewType: [FACILITIES_VIEW_TYPE, CENTRAL_TIMETABLER_VIEW_TYPE],
        accountType: [accountTypes.superAdmin, accountTypes.admin, accountTypes.facilities, accountTypes.centralTimetabler],
        campus: [2],
    },
    {
        title: 'Special Messages',
        route: '/special-messages',
        viewType: [FACILITIES_VIEW_TYPE, CENTRAL_TIMETABLER_VIEW_TYPE],
        accountType: [accountTypes.superAdmin, accountTypes.admin, accountTypes.facilities],
        campus: [2],
    },
    {
        title: 'Instructors',
        route: '/instructors',
        viewType: [ACADEMIC_VIEW_TYPE],
        accountType: [accountTypes.superAdmin, accountTypes.admin, accountTypes.timetabler],
    },
    {
        title: 'Accounts',
        route: '/accounts',
        viewType: [ACADEMIC_VIEW_TYPE],
        accountType: [accountTypes.superAdmin, accountTypes.admin],
    },
];

export const roomListItems = [
    {
        title: 'Configuration',
        route: '/room-configuration',
        viewType: [FACILITIES_VIEW_TYPE, ACADEMIC_VIEW_TYPE, CENTRAL_TIMETABLER_VIEW_TYPE],
        accountType: [accountTypes.superAdmin, accountTypes.admin, accountTypes.timetabler, accountTypes.facilities, accountTypes.centralTimetabler],
    },
    {
        title: 'Search',
        route: '/room-search',
        viewType: [FACILITIES_VIEW_TYPE, ACADEMIC_VIEW_TYPE, CENTRAL_TIMETABLER_VIEW_TYPE],
        accountType: [accountTypes.superAdmin, accountTypes.admin, accountTypes.timetabler, accountTypes.facilities, accountTypes.centralTimetabler],
    },
    {
        title: 'Conflicts',
        route: '/room-conflicts',
        viewType: [FACILITIES_VIEW_TYPE],
        accountType: [accountTypes.superAdmin, accountTypes.admin, accountTypes.facilities],
    },
];

// --------- Facilities ----------
export const reportListItems = [
    {
        title: 'Daily Grid',
        route: '/daily-grid',
        viewType: [FACILITIES_VIEW_TYPE, ACADEMIC_VIEW_TYPE, CENTRAL_TIMETABLER_VIEW_TYPE],
        accountType: [accountTypes.superAdmin, accountTypes.admin, accountTypes.facilities, accountTypes.centralTimetabler],
    },
    {
        title: 'GENRS List',
        route: '/genrs-list',
        viewType: [FACILITIES_VIEW_TYPE],
        accountType: [accountTypes.superAdmin, accountTypes.facilities],
    },
];

// --------- Facilities ----------
export const downloadsItems = [
    {
        title: 'Weekly Report',
        route: '/weekly-report',
        viewType: [FACILITIES_VIEW_TYPE],
        accountType: [accountTypes.superAdmin, accountTypes.facilities],
    },
    {
        title: 'Room Booking',
        route: '/room-booking-report',
        viewType: [FACILITIES_VIEW_TYPE],
        accountType: [accountTypes.superAdmin, accountTypes.facilities],
    },
];

export const publicSiteLiteItems = [
    {
        title: 'Terms',
        route: '/terms',
        viewType: [ACADEMIC_VIEW_TYPE],
        accountType: [accountTypes.superAdmin, accountTypes.admin, accountTypes.timetabler],
    },
    {
        title: 'Programs',
        route: '/programs',
        viewType: [ACADEMIC_VIEW_TYPE],
        accountType: [accountTypes.superAdmin, accountTypes.admin, accountTypes.timetabler],
    },
    {
        title: 'Exams',
        route: '/exams',
        viewType: [ACADEMIC_VIEW_TYPE],
        accountType: [accountTypes.superAdmin, accountTypes.admin, accountTypes.timetabler],
    },
];
